import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js'

@Injectable()
export class BsrmencryptionService {

  constructor() { }

  private base64Key = CryptoJS.enc.Utf8.parse('S40@s35$m34!T32h');
  private iv = CryptoJS.enc.Utf8.parse('A@m!tsm1n8MNZ^4I');
  private kSize = 128 / 8;
  
  // encrypted: string;
  // decrypted: string;
   
  public encryptString(message: string) : string
  {
    try{
    var encrypted = CryptoJS.AES.encrypt(
						message,
						this.base64Key,
						{
						    iv: this.iv
                            , mode: CryptoJS.mode.CBC,
                            padding: CryptoJS.pad.Pkcs7,
                            keySize: this.kSize
						}
          );
          var enc : string = encrypted.toString();
          //if(enc && enc.lastIndexOf("+") >= 0){
            enc = enc.split("+").join("___BSRMIT2019___");
            enc = enc.split("\n").join("___BSRMITSLASHN___");
            enc = enc.split("\r").join("___BSRMITSLASHR___");
            enc = enc.split("\t").join("___BSRMITSLASHT___");
           
          //}
          return enc;
    }
    catch(error) {
          return "";
    }
  }

  public decryptedString(encryptedMessage: string) : string
  {
    
    // if(encryptedMessage && encryptedMessage.lastIndexOf("*") >= 0){
    if(encryptedMessage && encryptedMessage.length >= 0){
      
      var splittedData  = encryptedMessage.split("___BSRMIT2019___");
      var joinedData = splittedData.join("+");

      var splittedData  = joinedData.split("___BSRMITSLASHN___");
      var joinedData = splittedData.join("\n");

      var splittedData  = joinedData.split("___BSRMITSLASHR___");
      var joinedData = splittedData.join("\r");

      var splittedData  = joinedData.split("___BSRMITSLASHT___");
      var joinedData = splittedData.join("\t");
      encryptedMessage = joinedData;
    }
    
    // encryptedMessage = str;
    // // encryptedMessage = encryptedMessage.split("*").join("+");
    try {
      var decrypted = CryptoJS.AES.decrypt(
                encryptedMessage,
                            this.base64Key,
                            {
                                iv: this.iv,
                                mode: CryptoJS.mode.CBC,
                                padding: CryptoJS.pad.Pkcs7,
                                keySize: this.kSize
                            }
                        );
      return  decrypted.toString(CryptoJS.enc.Utf8);
      } catch (error) {
        console.log('error in dec');
        console.log(error);
      return "";
    }
  }
}
